module.exports = __webpack_public_path__ + "img/logo-full-white.0e7233d9.svg";